import { render } from "./detailsPage.vue?vue&type=template&id=e98719a2&scoped=true&ts=true"
import script from "./detailsPage.vue?vue&type=script&lang=ts"
export * from "./detailsPage.vue?vue&type=script&lang=ts"

import "./detailsPage.vue?vue&type=style&index=0&id=e98719a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98719a2"]])

export default __exports__